import Page from 'front/pages/Page/Page';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';

import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

import {VIEWPORT_EVENTS} from '../../constants/Constants';
import './Post.less';
import * as Template from './Post.jinja';

const Selectors = {
    el: '.Post',
    sliderContainer: '.swiper-container',
    sliderNext: '.swiper-button-next',
    sliderPrev: '.swiper-button-prev'
};

const BindFunctions = [
    'onNext',
    'onPrev'
];

export default class Post extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.sliderNext}`]: this.onNext,
            [`${VIEWPORT_EVENTS.click} ${Selectors.sliderPrev}`]: this.onPrev
        };
    }

    constructor(options = {}) {
        options.el = '.Post';
        options.VIEWS_TO_REGISTER = {
            'top-bar': {selector: '.TopBar', viewConstructor: TopBar}
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        let $elInner = this.$('.Post-date')[0].innerHTML;
        if (!isNaN(new Date($elInner).getDate())) {
            const languageTextMonth = new Date($elInner)
                .toLocaleString(window.app.settings.language, {day: 'numeric', month: 'long', year: 'numeric'});

            this.$('.Post-date')[0].innerHTML = String(languageTextMonth).substr(0, languageTextMonth.length - 2);
        }

        this.swiper = new Swiper(Selectors.sliderContainer, {
            loop: true,
            speed: 500,
            resizeReInit: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: true
            },
            slidesPerView: 1,
            navigation: {
                nextEl: Selectors.sliderNext,
                prevEl: Selectors.sliderPrev
            }
        });
    }

    onNext() {
        // eslint-disable-next-line no-unused-expressions
        this.swiper.autoplay?.stop();
        this.observer.observe();
    }

    onPrev() {
        // eslint-disable-next-line no-unused-expressions
        this.swiper.autoplay?.stop();
        this.observer.observe();
    }
}
